// Maps internal API/backend field names to the user-facing labels we show in
// the customer portal. Keyed by the exact keys sent to the backend (see
// NewOrder.buildPayload and AddProductModal), so Sequelize validation-error
// `path` values resolve to labels users recognise. New screens can pass their
// own labels map to the shared formatter below instead of hardcoding text.
export const ORDER_FIELD_LABELS = {
  customerId: 'Customer',
  name: 'Order Name',
  deliveryAddressId: 'Delivery Address',
  deliveryContactId: 'Delivery Contact',
  deliveryName: 'Delivery Contact Name',
  phoneNo: 'Phone No',
  email: 'Delivery Contact Email',
  requiredDate: 'Required Date',
  invoiceDate: 'Invoice Date',
  dueDate: 'Due Date',
  paymentTerm: 'Payment Term',
  salesOrderGroup: 'SO Group',
  salesPerson: 'Sales Person',
  warehouseCode: 'Warehouse',
  purchaseOrderId: 'Purchase Order No',
  purchaseOrderDate: 'Purchase Order Date',
  purchaseOrderTotal: 'Purchase Order Total',
  deliveryInstruction: 'Delivery Instruction',
  config: 'Comments',
  productCode: 'Product Code',
  quantity: 'Quantity',
  rrp: 'RRP',
  customerPrice: 'Customer Price',
  finalPrice: 'Total Price',
  comments: 'Product Comments',
};

export function resolveFieldLabel(path, labels) {
  if (!path) return '';
  if (labels[path]) return labels[path];
  const leafKey = String(path).split(/[.[]/).pop().replace(/\]/g, '');
  return labels[leafKey] || path;
}

// Turns one Sequelize validation detail ({ path, message }) into a user-facing
// line: renames any raw API field name inside the message to its label, and
// prepends the label when the message doesn't already mention it.
export function formatSequelizeLine(item, labels) {
  const path = typeof item?.path === 'string' ? item.path : '';
  const message = typeof item?.message === 'string' ? item.message : '';
  const label = resolveFieldLabel(path, labels);
  let line = message;

  if (path && label && label !== path) {
    const pathRe = new RegExp(`\\b${escapeRegExp(path)}\\b`, 'gi');
    const leafRe = new RegExp(`\\b${escapeRegExp(leafKey(path))}\\b`, 'gi');
    line = line.replace(pathRe, label).replace(leafRe, label);
  }

  if (label && !line.toLowerCase().includes(label.toLowerCase())) {
    line = line ? `${label} ${line}` : label;
  }

  return line;
}

function leafKey(path) {
  return String(path).split(/[.[]/).pop().replace(/\]/g, '');
}

function escapeRegExp(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
